import { IEnableSpecifiable } from "../../../../base/domain/drawing";

export interface IDecimalRoundBehavior extends IEnableSpecifiable {
  numberOfDecimalPlaces: number;
  kind: RoundKinds;
}

export enum RoundKinds {
  Round = 1,
  Ceil = 2,
  Floor = 3,
}
